/* LNC About V2 — journey cross-fade + counters + timeline fill + gallery parallax */
(function () {
  'use strict';

  var root = document.querySelector('.lnc-about-v2');
  if (!root) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* -------- IntersectionObserver fade-ups (mobile cards, timeline, mission) -------- */
  var revealEls = root.querySelectorAll('[data-reveal]');
  if (revealEls.length) {
    if (!('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
      revealEls.forEach(function (el) { io.observe(el); });
    }
  }

  /* -------- Journey scene cross-fade (desktop, pinned scroll) -------- */
  var scenes = root.querySelectorAll('[data-scene]');
  var copies = root.querySelectorAll('[data-scene-copy]');
  var dots = root.querySelectorAll('[data-scene-dot]');
  var sceneCount = scenes.length;
  var lastIdx = -1;

  var setActive = function (idx) {
    if (idx === lastIdx) return;
    lastIdx = idx;
    scenes.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
    copies.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
    dots.forEach(function (el, i) {
      el.classList.toggle('is-past', i < idx);
      el.classList.toggle('is-active', i === idx);
    });
  };

  function initGSAP() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    /* Hero heading character reveal */
    var heading = root.querySelector('[data-hero-heading]');
    if (heading && !prefersReducedMotion) {
      var text = heading.textContent;
      heading.textContent = '';
      heading.setAttribute('aria-label', text);
      var words = text.split(' ');
      words.forEach(function (w, wi) {
        var wSpan = document.createElement('span');
        wSpan.style.display = 'inline-block';
        wSpan.style.whiteSpace = 'nowrap';
        for (var i = 0; i < w.length; i++) {
          var cs = document.createElement('span');
          cs.textContent = w[i];
          cs.style.display = 'inline-block';
          cs.style.opacity = '0';
          cs.style.transform = 'translateY(22px)';
          wSpan.appendChild(cs);
        }
        heading.appendChild(wSpan);
        if (wi < words.length - 1) heading.appendChild(document.createTextNode(' '));
      });
      var chars = heading.querySelectorAll('span > span');
      gsap.to(chars, { opacity: 1, y: 0, duration: 0.7, stagger: 0.025, ease: 'power3.out', delay: 0.15 });
    }

    /* Journey: pin + scene cross-fade (desktop, motion OK) */
    if (sceneCount > 0 && !prefersReducedMotion) {
      var mm = gsap.matchMedia();
      mm.add('(min-width: 900px)', function () {
        var st = ScrollTrigger.create({
          trigger: '#journey',
          start: 'top top',
          end: '+=' + (sceneCount * 80) + '%',
          pin: true,
          scrub: 0.4,
          onUpdate: function (self) {
            var idx = Math.min(sceneCount - 1, Math.floor(self.progress * sceneCount * 0.999));
            setActive(idx);
          },
        });
        return function () { st.kill(); };
      });
    }

    /* Stat counters */
    root.querySelectorAll('[data-stat-target]').forEach(function (el) {
      var target = parseInt(el.getAttribute('data-stat-target'), 10) || 0;
      ScrollTrigger.create({
        trigger: el,
        start: 'top 85%',
        once: true,
        onEnter: function () { animateCounter(el, target, 1.6); },
      });
    });

    /* Timeline fill */
    var fill = root.querySelector('.lnc-about-v2__timeline-fill');
    if (fill) {
      gsap.to(fill, {
        scaleY: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: '.lnc-about-v2__timeline',
          start: 'top 75%',
          end: 'bottom 75%',
          scrub: true,
        },
      });
    }

    /* Gallery parallax */
    root.querySelectorAll('[data-parallax]').forEach(function (el) {
      gsap.to(el, {
        yPercent: -8,
        ease: 'none',
        scrollTrigger: { trigger: el, scrub: true, start: 'top bottom', end: 'bottom top' },
      });
    });
  }

  function animateCounter(el, target, duration) {
    var t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / (duration * 1000), 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.floor(eased * target).toString();
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = target.toString();
    }
    requestAnimationFrame(step);
  }

  /* Fallback counter path (no GSAP) */
  function fallbackCounters() {
    var stats = root.querySelectorAll('[data-stat-target]');
    if (!stats.length || !('IntersectionObserver' in window)) {
      stats.forEach(function (s) { s.textContent = s.getAttribute('data-stat-target'); });
      return;
    }
    var io2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var t = parseInt(e.target.getAttribute('data-stat-target'), 10) || 0;
        animateCounter(e.target, t, 1.6);
        io2.unobserve(e.target);
      });
    }, { threshold: 0.3 });
    stats.forEach(function (s) { io2.observe(s); });
  }

  if (window.__gsapReady && typeof window.__gsapReady.then === 'function') {
    window.__gsapReady.then(initGSAP).catch(fallbackCounters);
  } else if (typeof gsap !== 'undefined') {
    initGSAP();
  } else {
    fallbackCounters();
  }
})();
